import axios from 'axios';
import { User } from 'types';

export function setAuthHeader(token: string | undefined | null) {
  if (token) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    axios.defaults.headers.common.Authorization = token;
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    delete axios.defaults.headers.common.Authorization;
  }
}

export interface SessionState {
  user: User | null | undefined;
  token: string | null;
  refresh: string | null;
  complete?: boolean;
}
type WithTokens<T> = T & {
  Token?: string | null;
  Refresh?: string | null;
};

type Actions =
  | {
      type: 'setUser';
      data: WithTokens<User>;
    }
  | {
      type: 'logout';
      data?: undefined;
    }
  | {
      type: 'setSession';
      data: WithTokens<{
        User: User;
      }>;
    }
  | {
      type: 'updateTokens';
      data: WithTokens<undefined>;
    }
  | {
      type: 'complete';
      data?: undefined;
    };

export function sessionReducer(state: SessionState, { type, data }: Actions) {
  const getTokens = () => {
    const tokens = {
      token: data?.Token ?? null,
      refresh: data?.Refresh ?? null,
    };
    localStorage.setItem('token', tokens.token ?? '');
    localStorage.setItem('refresh', tokens.refresh ?? '');
    return tokens;
  };
  switch (type) {
    case 'setUser':
      return { ...state, user: data, complete: true };
    case 'logout': {
      const newState = {
        user: null,
        token: null,
        refresh: null,
        complete: true,
      };
      setAuthHeader(newState.token);
      localStorage.removeItem('token');
      localStorage.removeItem('refresh');
      return newState;
    }
    case 'setSession': {
      const newState = { user: data.User, ...getTokens(), complete: true };
      setAuthHeader(newState.token);
      return newState;
    }
    case 'updateTokens': {
      const newState = {
        ...state,
        ...getTokens(),
      };
      setAuthHeader(newState.token);
      return newState;
    }
    case 'complete': {
      return {
        ...state,
        complete: true,
      };
    }
    default:
      return state;
  }
}
